import Controller from "./corporates.controller";
import template from "./corporates.html";

const corporates = {
  template,
  controller: Controller,
};

export default corporates;



// WEBPACK FOOTER //
// ./src/pages/corporates/corporates.component.js